import React from "react";
import './MatchRefundModal.css';
import { Box, Dialog, Grid, DialogTitle, DialogActions, DialogContent, TextField, FormControl, InputLabel, Select, Autocomplete, TableContainer, Checkbox, Paper, Chip } from '@mui/material';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { sub } from "date-fns";
import { useEffect } from "react";

const MatchRefundModal = ({
    openWithdrawRefundModal, row,
    handleCloseRefundModals,
    itemImg,
    calculatedTotalFoodItemPrice,
    selectedRowToRefund,
    handleCheckboxSelection,
    RefundValidationError,
    setRefundReason,
    refundReason,
    addOnToRefund,
    selectedRefundProcessingType,
    setSelectedRefundProcessingType,
    emailAddressToSendRefundPaymentForm = null,
    setEmailAddressToSendRefundPaymentForm,
    closeIcon,
    selectedPartialRefundItems,
    alteredQuantity,
    AddAddONPriceWithTotal,
    handleAddonCheckbox,
    handleQuantityChange,
    refundProcessingType,
    WithdrawRefundRequest,
    WithdrawPartialRefundRequest,
    withdrawPartialRefundOnAction,
    GetAllTransaction,
    selectedTransactionToRefundFrom,
    withdrawRefundTransactionSelection,
    checkForRequiredAmountToWithdraw,
    hasRemainingAmount,
    selectedRestaurant,
    bankDetailsList,
    setSelectedBank,
    selectedBank,
    refundProcessingTypeValidationError,
    emailValidationError
}) => {
    // #region Match Refund Modal's total calculation and state management
    const [alreadyPartialRefunded, setAlreadyPartialRefunded] = React.useState(false);
    const [totalRefundAmount, setTotalRefundAmount] = React.useState("0.00");

    const CalculateFoodItemTipsAndServiceCharge = (item: any, selectedRowToRefund: any, type: string, calculationType: string) => {
        const totalOrderPrice = selectedRowToRefund?.totalItemPrice || 0;
        const totalOrderTips = selectedRowToRefund?.totalTips || 0;
        const totalOrderServiceCharge = selectedRowToRefund?.totalServiceCharge || 0;
        const foodItemPrice = (item?.basePrice + item?.vatInAmount + item?.sdInAmount) * item?.qty || 0;

        switch (type) {
            case "Tips":
                if (calculationType === 'itemWise') {
                    return ((foodItemPrice / totalOrderPrice) * totalOrderTips) / item.qty;
                }
                return ((foodItemPrice / totalOrderPrice) * totalOrderTips);
            case "ServiceCharge":
                if (calculationType === 'itemWise') {
                    return (((foodItemPrice / totalOrderPrice) * totalOrderServiceCharge) / item.qty);
                }
                return ((foodItemPrice / totalOrderPrice) * totalOrderServiceCharge);
        }
    }

    const CalculateAddonTipsAndServiceCharage = (item, selectedRowToRefund, type) => {
        const totalOrderPrice = selectedRowToRefund?.totalItemPrice || 0;
        const totalOrderTips = selectedRowToRefund?.totalTips || 0;
        const totalOrderServiceCharge = selectedRowToRefund?.totalServiceCharge || 0;
        const addonPrice = CalculateFullAddonTotalPrice(item?.addons) || 0;

        switch (type) {
            case "Tips":
                return ((addonPrice / totalOrderPrice) * totalOrderTips).toFixed(2);
            case "ServiceCharge":
                return ((addonPrice / totalOrderPrice) * totalOrderServiceCharge).toFixed(2);
        }
    }

    const CalculateSingleAddonTotalPrice = (addOn) => {
        if (!addOn || typeof addOn !== 'object') return 0;

        const optionTotal = (Array.isArray(addOn.options) ? addOn.options : []).reduce((optSum, option) => {
            const optionPrice = option.totalPrice || 0;

            const subOptionTotal = (Array.isArray(option.subOptions) ? option.subOptions : []).reduce((subSum, sub) => {
                return subSum + (sub.totalPrice || 0);
            }, 0);

            return optSum + optionPrice + subOptionTotal;
        }, 0);

        const addonPrice = (addOn.totalPrice || 0) + optionTotal;
        return addonPrice;
    };

    /** Check if already partial refunded */
    useEffect(() => {
        selectedRowToRefund?.items?.forEach(item => {
            if (item.qty !== item.initialQty) {
                setAlreadyPartialRefunded(true);
            }
        });
    }, [selectedRowToRefund]);

    const CalculatedServiceChargeVat = (item, rowToRefund) => {
        var foundQtyChanged = alteredQuantity.find(element => element.orderItemId === item.orderItemId);
        const totalOrderPrice = selectedRowToRefund?.totalItemPrice || 0;
        const foodItemPrice = (item?.basePrice + item?.vatInAmount + item?.sdInAmount) * (foundQtyChanged ? foundQtyChanged.quantity : item?.qty);
        const totalServiceChargeVat = selectedRowToRefund?.totalServiceChargeVat || 0;

        return foodItemPrice / totalOrderPrice * totalServiceChargeVat;
    }

    /** Calculate Total Refund Amount */
    const CalculateTotalRefundAmountManually = (selectedRowToRefund) => {
        if (!selectedRowToRefund) return "0.00";

        const total = selectedRowToRefund?.items?.filter(item => item.qty !== 0).reduce((total, item) => {
            const itemTotal = (item.basePrice + item.sdInAmount + item.vatInAmount) * item.qty;
            const itemTips = CalculateFoodItemTipsAndServiceCharge(item, selectedRowToRefund, "Tips", "");
            const itemServiceCharge = CalculateFoodItemTipsAndServiceCharge(item, selectedRowToRefund, "ServiceCharge", "");
            var FoodItemServiceChargeVat = CalculatedServiceChargeVat(item, selectedRowToRefund, "item");

            const addOnAmount = (item?.addons || []).filter(addon => addon.refundStatus !== "Refunded").reduce((addOnTotal, addon) => {
                const addonPrice = CalculateSingleAddonTotalPrice(addon);
                const addonTips = CalculateAddonTipsAndServiceCharage(addon, selectedRowToRefund, "Tips");
                const addonServiceCharge = CalculateAddonTipsAndServiceCharage(addon, selectedRowToRefund, "ServiceCharge");
                var addonServiceChargeVat = CalculatedServiceChargeVat(item, selectedRowToRefund, "addOn");
                return addOnTotal + addonPrice + parseFloat((addonTips)) + parseFloat((addonServiceCharge)) + parseFloat((addonServiceChargeVat));
            }, 0);

            return total + itemTotal + addOnAmount + itemTips + itemServiceCharge + FoodItemServiceChargeVat;
        }, 0);

        return total.toFixed(2);
    };

    useEffect(() => {
        if (alreadyPartialRefunded && selectedRowToRefund) {
            const totalAmount = CalculateTotalRefundAmountManually(selectedRowToRefund);
            setTotalRefundAmount(totalAmount);
        }

    }, [alreadyPartialRefunded, selectedRowToRefund]);

    const CalculateFullAddonTotalPrice = (addons) => {
        if (!addons) return 0;

        const addonArray = Array.isArray(addons) ? addons : [addons];

        return addonArray.reduce((sum, addOn) => {
            if (addOn.refundStatus === 'Refunded') return 0;

            var found = addOnToRefund.find(element => element.addOnId === addOn.addOnId);
            if (!found) return sum;

            const optionTotal = (Array.isArray(addOn.options) ? addOn.options : []).reduce((optSum, option) => {
                const optionPrice = option.totalPrice || 0;
                const subOptionTotal = (Array.isArray(option.subOptions) ? option.subOptions : []).reduce((subSum, sub) => {
                    return subSum + (sub.totalPrice || 0);
                }, 0);
                return optSum + optionPrice + subOptionTotal;
            }, 0);

            const addonPrice = (addOn.totalPrice || 0) + optionTotal;
            return sum + addonPrice;
        }, 0);
    };

    const CalculateFullAddonTotalPriceForFullRefund = (addons) => {
        if (!addons) return 0;

        const addonArray = Array.isArray(addons) ? addons : [addons];

        return addonArray.reduce((sum, addOn) => {
            if (addOn.refundStatus === 'Refunded') return 0;

            const optionTotal = (Array.isArray(addOn.options) ? addOn.options : []).reduce((optSum, option) => {
                const optionPrice = option.totalPrice || 0;
                const subOptionTotal = (Array.isArray(option.subOptions) ? option.subOptions : []).reduce((subSum, sub) => {
                    return subSum + (sub.totalPrice || 0);
                }, 0);
                return optSum + optionPrice + subOptionTotal;
            }, 0);

            const addonPrice = (addOn.totalPrice || 0) + optionTotal;
            return sum + addonPrice;
        }, 0);
    };

    const CalculateAddonFullTipsAndServiceCharage = (item, type: string) => {
        var itemTotalTips = selectedRowToRefund.totalTips;
        var serviceCharge = selectedRowToRefund.totalServiceCharge;
        const totalOrderPrice = selectedRowToRefund?.totalItemPrice || 0;

        var addonTotalAmount = item?.addons?.filter(element => element.refundStatus !== "Refunded").reduce((accumulator, addon) => {
            const addonTotal = addon.totalPrice || 0;

            const optionsTotal = addon?.options?.reduce((optAcc, option) => {
                const optionTotal = option.totalPrice || option.basePrice || 0;

                const subOptionsTotal = option.subOptions?.reduce((subAcc, sub) => {
                    return subAcc + (sub.totalPrice || sub.basePrice || 0);
                }, 0);

                return optAcc + optionTotal + subOptionsTotal;
            }, 0);

            return accumulator + addonTotal + optionsTotal;
        }, 0);

        if (type === "Tips") {
            return (addonTotalAmount / totalOrderPrice) * itemTotalTips;
        }

        if (type === "ServiceCharge") {
            return (addonTotalAmount / totalOrderPrice) * serviceCharge;
        }
    }

    const GetFoodItemTotalAmount = (item) => {
        var itemPrice = (item.basePrice + item.sdInAmount + item.vatInAmount) * item.qty
        var FoodItemTips = CalculateFoodItemTipsAndServiceCharge(item, selectedRowToRefund, "Tips", "")
        var FoodItemServiceCharge = CalculateFoodItemTipsAndServiceCharge(item, selectedRowToRefund, "ServiceCharge", "");
        var FoodItemServiceChargeVat = CalculatedServiceChargeVat(item, selectedRowToRefund, "item");

        var AddOnTotalPrice = CalculateFullAddonTotalPriceForFullRefund(item?.addons);
        var addonTips = CalculateAddonFullTipsAndServiceCharage(item, "Tips");
        var addonServiceCharge = CalculateAddonFullTipsAndServiceCharage(item, "ServiceCharge");
        var addonServiceChargeVat = CalculatedServiceChargeVatForAddOn(item, selectedRowToRefund, "addOn");

        return itemPrice + FoodItemTips + FoodItemServiceCharge + FoodItemServiceChargeVat + AddOnTotalPrice + addonTips + addonServiceCharge + addonServiceChargeVat;
    };

    // #endregion

    // #region Partial Match Refund Functionality
    const CalculateSinglePartialAddonTotalPrice = (addons) => {
        if (!addons) return 0;

        const addonArray = Array.isArray(addons) ? addons : [addons];

        return addonArray.reduce((sum, addOn) => {
            if (addOn.refundStatus === 'Refunded') return;
            var found = addOnToRefund.find(element => element.addOnId === addOn.addOnId);
            if (!found) {
                if (selectedPartialRefundItems?.length !== 0) {
                    if (!addOn || typeof addOn !== 'object') return sum;
                    const optionTotal = (Array.isArray(addOn.options) ? addOn.options : []).reduce((optSum, option) => {
                        const optionPrice = option.totalPrice || 0;
                        const subOptionTotal = (Array.isArray(option.subOptions) ? option.subOptions : []).reduce((subSum, sub) => {
                            return subSum + (sub.totalPrice || 0);
                        }, 0);
                        return optSum + optionPrice + subOptionTotal;
                    }, 0);
                    const addonPrice = (addOn.totalPrice || 0) + optionTotal;
                    return sum + addonPrice;
                }
                return;
            }
            if (!addOn || typeof addOn !== 'object') return sum;

            const optionTotal = (Array.isArray(addOn.options) ? addOn.options : []).reduce((optSum, option) => {
                const optionPrice = option.totalPrice || 0;
                const subOptionTotal = (Array.isArray(option.subOptions) ? option.subOptions : []).reduce((subSum, sub) => {
                    return subSum + (sub.totalPrice || 0);
                }, 0);
                return optSum + optionPrice + subOptionTotal;
            }, 0);
            const addonPrice = (addOn.totalPrice || 0) + optionTotal;
            return sum + addonPrice;
        }, 0);
    };

    const CalculatePartialAddonTipsAndServiceCharage = (item, selectedRowToRefund, type) => {
        const totalOrderPrice = selectedRowToRefund?.totalItemPrice || 0;

        const totalOrderTips = selectedRowToRefund?.totalTips || 0;
        const totalOrderServiceCharge = selectedRowToRefund?.totalServiceCharge || 0;
        const addonPrice = CalculateFullAddonTotalPrice(item?.addons) || 0;

        switch (type) {
            case "Tips":
                return ((addonPrice / totalOrderPrice) * totalOrderTips).toFixed(2);
            case "ServiceCharge":
                return ((addonPrice / totalOrderPrice) * totalOrderServiceCharge).toFixed(2);
        }
    }

    const GetItemPrice = (item) => {
        const found = alteredQuantity.some(element => element.orderItemId === item.orderItemId);
        if (found) {
            var find = alteredQuantity?.find(element => element?.orderItemId === item?.orderItemId);
            return ((item.basePrice + item.vatInAmount + item.sdInAmount) * find?.quantity).toFixed(2);
        } else {
            return ((item.basePrice + item.vatInAmount + item.sdInAmount) * item.qty).toFixed(2);
        }
    }

    const GetItemTips = (item) => {
        const found = alteredQuantity.some(element => element.orderItemId === item.orderItemId);
        if (found) {
            return CalculatePartialFoodItemTipsAndServiceCharge(item, selectedRowToRefund, "Tips", "itemWise").toFixed(2);
        } else {
            return CalculatePartialFoodItemTipsAndServiceCharge(item, selectedRowToRefund, "Tips", "").toFixed(2);
        }
    }

    const GetItemServiceCharge = (item) => {
        const found = alteredQuantity.some(element => element.orderItemId === item.orderItemId);
        if (found) {
            return CalculatePartialFoodItemTipsAndServiceCharge(item, selectedRowToRefund, "ServiceCharge", "itemWise").toFixed(2);
        } else {
            return CalculatePartialFoodItemTipsAndServiceCharge(item, selectedRowToRefund, "ServiceCharge", "").toFixed(2);
        }
    }

    const CalculatePartialFoodItemTipsAndServiceCharge = (item: any, selectedRowToRefund: any, type: string, calculationType: string) => {
        const totalOrderPrice = selectedRowToRefund?.totalItemPrice || 0;
        const totalOrderTips = selectedRowToRefund?.totalTips || 0;
        const totalOrderServiceCharge = selectedRowToRefund?.totalServiceCharge || 0;
        var found = alteredQuantity.find(element => element.orderItemId === item.orderItemId);
        const foodItemPrice = (item?.basePrice + item?.vatInAmount + item?.sdInAmount) * (found ? found.quantity : item?.qty) || 0;

        switch (type) {
            case "Tips":
                if (calculationType === 'itemWise') {
                    var find = alteredQuantity?.find(element => element.orderItemId === item.orderItemId);
                    if (find) {
                        var itemPrice = GetItemPrice(item);
                        var result = ((itemPrice / totalOrderPrice) * totalOrderTips);
                        return result;
                    } else {
                        return ((foodItemPrice / totalOrderPrice) * totalOrderTips);
                    }
                }
                return ((foodItemPrice / totalOrderPrice) * totalOrderTips);
            case "ServiceCharge":
                if (calculationType === 'itemWise') {
                    var find = alteredQuantity?.find(element => element.orderItemId === item.orderItemId);
                    if (find) {
                        var itemPrice = GetItemPrice(item);
                        return ((itemPrice / totalOrderPrice) * totalOrderServiceCharge);
                    } else {
                        return ((foodItemPrice / totalOrderPrice) * totalOrderServiceCharge) / item.qty;
                    }
                }
                return ((foodItemPrice / totalOrderPrice) * totalOrderServiceCharge);
        }
    }

    const GetPartialFoodItemTotalAmount = (item) => {
        var found = alteredQuantity.find(element => element.orderItemId === item.orderItemId)
        var itemPrice = (item.basePrice + item.sdInAmount + item.vatInAmount) * (found ? found.quantity : item.qty);
        var FoodItemTips = CalculatePartialFoodItemTipsAndServiceCharge(item, selectedRowToRefund, "Tips", "")
        var FoodItemServiceCharge = CalculatePartialFoodItemTipsAndServiceCharge(item, selectedRowToRefund, "ServiceCharge", "");
        var FoodItemServiceChargeVat = CalculatedServiceChargeVat(item, selectedRowToRefund, "item");

        var AddOnTotalPrice = CalculateFullAddonTotalPrice(item?.addons);
        var addonTips = parseFloat(CalculateAddonTipsAndServiceCharage(item, selectedRowToRefund, "Tips"));
        var addonServiceCharge = parseFloat(CalculateAddonTipsAndServiceCharage(item, selectedRowToRefund, "ServiceCharge"));
        var addonServiceChargeVat = CalculatedServiceChargeVatForAddOn(item, selectedRowToRefund);

        return itemPrice + FoodItemTips + FoodItemServiceCharge + FoodItemServiceChargeVat + AddOnTotalPrice + addonTips + addonServiceCharge + addonServiceChargeVat;
    }

    const CalculatedServiceChargeVatForAddOn = (item, rowToRefund) => {
        var foundQtyChanged = alteredQuantity.find(element => element.orderItemId === item.orderItemId);
        const foodItemPrice = (item?.basePrice + item?.vatInAmount + item?.sdInAmount) * item?.qty || 0;

        const totalOrderPrice = selectedRowToRefund?.totalItemPrice || 0;
        const totalServiceChargeVat = selectedRowToRefund?.totalServiceChargeVat || 0;
        const addOnPrice = withdrawPartialRefundOnAction === false ? CalculateFullAddonTotalPriceForFullRefund(item?.addons) : CalculateFullAddonTotalPrice(item?.addons);

        return addOnPrice / totalOrderPrice * totalServiceChargeVat;
    }
    // #endregion

    return (
        < Dialog
            fullWidth={true}
            maxWidth={"xl"}
            open={openWithdrawRefundModal}
            onClose={handleCloseRefundModals}
        >
            {/* Header */}
            < Grid container className="d-flex space-between align-items-center" style={{ backgroundColor: 'rgb(86, 89, 91)' }}>
                {/* Logo & header - dialouge header */}
                < Grid item xs={6} >
                    <DialogTitle>
                        <div className="d-flex" style={{ gap: "8px" }}>
                            {/* Logo */}
                            <div>
                                <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                            </div>
                            {/* Header */}
                            <span style={{ color: "white" }}>{withdrawPartialRefundOnAction ? "Partial Match Refund" : "Match Refund"}</span>
                        </div>
                    </DialogTitle>
                </Grid >

                {/* Close button - header */}
                < Grid item xs={6} >
                    <DialogActions>
                        <Button onClick={() => handleCloseRefundModals()}>
                            <img
                                src={closeIcon}
                                alt="Close"
                                style={{ width: "1.2rem" }}
                            />
                        </Button>
                    </DialogActions>
                </Grid >
            </Grid >

            <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
                {/* Withdraw Refund Content */}
                {withdrawPartialRefundOnAction === false &&
                    <div>
                        <Box sx={{ mb: 2, p: 2, background: '#f8f9fa', borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div>
                                <Typography variant="h6" sx={{ mt: 1, mb: 0.5, color: '#2a7fd4', fontWeight: 700 }}>
                                    Refund Amount: ￡{alreadyPartialRefunded
                                        ? totalRefundAmount
                                        : (selectedRowToRefund?.totalItemPrice +
                                            selectedRowToRefund?.totalTips +
                                            selectedRowToRefund?.totalServiceCharge +
                                            selectedRowToRefund?.totalServiceChargeVat
                                        ).toFixed(2)}
                                </Typography>

                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                    Refund Summary
                                </Typography>

                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                    <strong>Refund Order ID:</strong> <span style={{ color: '#2a7fd4' }}>#{selectedRowToRefund?.id?.slice(-6)}</span>
                                </Typography>

                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                    <strong>Total Order Price:</strong> ￡{selectedRowToRefund?.totalPrice?.toFixed(2) ?? '0.00'}
                                </Typography>

                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                    <strong>Total Withdrawn Amount:</strong> ￡{selectedRowToRefund?.totalWithdrawnAmount?.toFixed(2) ?? '0.00'}
                                </Typography>

                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                    <strong>Total Remaining Amount:</strong> ￡{(selectedRowToRefund?.totalPrice - selectedRowToRefund?.totalTransactionFees - selectedRowToRefund?.totalWithdrawnAmount).toFixed(2)}
                                </Typography>

                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                    <strong>Total Transaction Fees:</strong> ￡{selectedRowToRefund?.totalTransactionFees?.toFixed(2) ?? '0.00'}
                                </Typography>

                                <div style={{ borderBottom: '1px solid #e0e0e0', margin: '12px 0', width: '300px' }} />

                                {/* Total Refunded Amount from other orders */}
                                <Typography
                                    variant="body2"
                                    sx={{
                                        mb: 0.5,
                                        background: 'rgba(113, 120, 128, 0.2)',
                                        width: 'fit-content',
                                        color: '#020202ff',
                                        borderRadius: '4px',
                                        px: 1
                                    }}
                                >
                                    <strong>Total Amount Needed from Other Order:</strong> ￡{
                                        (
                                            (alreadyPartialRefunded
                                                ? parseFloat(totalRefundAmount)
                                                : (
                                                    selectedRowToRefund?.totalPrice
                                                )
                                            ) - (selectedRowToRefund?.totalPrice - selectedRowToRefund?.totalTransactionFees - selectedRowToRefund?.totalWithdrawnAmount || 0)
                                        ).toFixed(2)
                                    }
                                </Typography>
                            </div>

                            {/* Download Report Button */}
                            {/* <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => {
                                        import('jspdf').then(jsPDFModule => {
                                            const jsPDF = jsPDFModule.jsPDF;
                                            const doc = new jsPDF();

                                            // Prepare the data
                                            const refundAmount = alreadyPartialRefunded
                                                ? totalRefundAmount
                                                : (selectedRowToRefund?.totalItemPrice +
                                                    selectedRowToRefund?.totalTips +
                                                    selectedRowToRefund?.totalServiceCharge +
                                                    selectedRowToRefund?.totalServiceChargeVat
                                                ).toFixed(2);

                                            const refundOrderId = selectedRowToRefund?.id?.slice(-6);
                                            const totalWithdrawnAmount = selectedRowToRefund?.totalWithdrawnAmount?.toFixed(2) ?? '0.00';
                                            const totalRemainingAmount = (selectedRowToRefund?.totalPrice - selectedRowToRefund?.totalTransactionFees - selectedRowToRefund?.totalWithdrawnAmount).toFixed(2);
                                            const totalTransactionFees = selectedRowToRefund?.totalTransactionFees?.toFixed(2) ?? '0.00';
                                            const totalAmountNeeded = (
                                                (alreadyPartialRefunded
                                                    ? parseFloat(totalRefundAmount)
                                                    : (
                                                        selectedRowToRefund?.totalPrice
                                                    )
                                                ) - (selectedRowToRefund?.totalPrice - selectedRowToRefund?.totalTransactionFees - selectedRowToRefund?.totalWithdrawnAmount || 0)
                                            ).toFixed(2);

                                            // Add content to PDF
                                            doc.setFontSize(16);
                                            doc.text(`Refund Amount: £${refundAmount}`, 10, 20);
                                            doc.setFontSize(12);
                                            doc.text(`Refund Summary`, 10, 30);
                                            doc.text(`Refund Order ID: #${refundOrderId}`, 10, 40);
                                            doc.text(`Total Withdrawn Amount: £${totalWithdrawnAmount}`, 10, 50);
                                            doc.text(`Total Remaining Amount: £${totalRemainingAmount}`, 10, 60);
                                            doc.text(`Total Transaction Fees: £${totalTransactionFees}`, 10, 70);
                                            doc.text(`Total Amount Needed from Other Order: £${totalAmountNeeded}`, 10, 80);

                                            doc.save(`refund-summary-${refundOrderId}.pdf`);
                                        });
                                    }}
                                >
                                    Download PDF
                                </Button>
                            </Box> */}
                        </Box>

                        <hr />

                        {/* Item Details for Full Match Refund */}
                        <div style={{ padding: '8px' }}>
                            <TableContainer component={Paper} elevation={0}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ textWrap: 'nowrap' }}><strong>Item Name</strong></TableCell>
                                            <TableCell align="center"><strong>Quantity</strong></TableCell>
                                            <TableCell style={{ textWrap: 'nowrap' }}><strong>Item Tips</strong></TableCell>
                                            <TableCell style={{ textWrap: 'nowrap' }}><strong>Item Service Charge</strong></TableCell>
                                            <TableCell style={{ textWrap: 'nowrap' }}><strong>Item Service Charge VAT</strong></TableCell>

                                            <TableCell align="center"><strong>Addon Details</strong></TableCell>
                                            <TableCell align="center"><strong>AddOn Tips</strong></TableCell>
                                            <TableCell align="center"><strong>AddOn Service Charge</strong></TableCell>
                                            <TableCell align="center"><strong>AddOn Service Charge VAT</strong></TableCell>
                                            <TableCell align="center"><strong>Total Amount</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedRowToRefund?.items?.filter(item => item.qty > 0)?.map((item, index) => (
                                            <React.Fragment key={index}>
                                                <TableRow>
                                                    {/* Item Name & Price */}
                                                    <TableCell>
                                                        <Typography style={{ fontWeight: 'bold', textWrap: 'nowrap' }}>{item.orderItemName} - ￡{((item.basePrice + item.vatInAmount + item.sdInAmount) * item.qty).toFixed(2)}</Typography>
                                                    </TableCell>

                                                    {/* Item Quantity */}
                                                    <TableCell align="center">
                                                        <Typography>{item.qty}</Typography>
                                                    </TableCell>

                                                    {/* Item Tips */}
                                                    <TableCell align="center">
                                                        <Typography>{CalculateFoodItemTipsAndServiceCharge(item, selectedRowToRefund, "Tips", "").toFixed(2)}</Typography>
                                                    </TableCell>

                                                    {/* Item Service Charge */}
                                                    <TableCell align="center">
                                                        <Typography>{CalculateFoodItemTipsAndServiceCharge(item, selectedRowToRefund, "ServiceCharge", "").toFixed(2)}</Typography>
                                                    </TableCell>

                                                    {/* Item Service Charge */}
                                                    <TableCell align="center">
                                                        <Typography>{CalculatedServiceChargeVat(item, selectedRowToRefund, "item").toFixed(2)}</Typography>
                                                    </TableCell>

                                                    {/* AddOn Details */}
                                                    <TableCell align="center" style={{ textWrap: 'nowrap' }}>
                                                        {item?.addons?.length > 0 ? (
                                                            <div>
                                                                <div>
                                                                    {item.addons.map((addon, aIdx) => (
                                                                        <div key={aIdx} style={{ marginBottom: '0.5rem', marginLeft: 8 }}>
                                                                            {addon.refundStatus === "Refunded" ?
                                                                                <p style={{ fontWeight: 'bold', color: 'green', fontSize: 12, margin: '0px', padding: '0px' }}>{addon.addOnName} is already refunded</p>
                                                                                :
                                                                                <>
                                                                                    {item.addons.length > 1 && (
                                                                                        <span style={{ marginRight: 6 }}>{aIdx + 1}.</span>
                                                                                    )}
                                                                                    <span style={{ fontWeight: 'bold' }}>{addon.addOnName}</span>
                                                                                    <span style={{ marginLeft: 8 }}>￡{addon.totalPrice}</span>
                                                                                    {addon?.refundStatus === "Refunded" ? (
                                                                                        <span style={{ marginLeft: 8 }}>
                                                                                            <span style={{ background: '#dc3545', color: 'white', borderRadius: 8, padding: '2px 8px', fontSize: 12 }}>Refunded</span>
                                                                                        </span>
                                                                                    ) : (
                                                                                        addOnToRefund.some(item => item.id === addon.id) &&
                                                                                        <span style={{ marginLeft: 8, color: 'gray', fontSize: 12 }}>Will refund</span>
                                                                                    )}
                                                                                    {/* Options */}
                                                                                    {addon?.options?.length > 0 && (
                                                                                        <div style={{ marginLeft: '1.5rem', marginTop: '0.2rem' }}>
                                                                                            {addon.options.map((option, oIdx) => (
                                                                                                <div key={oIdx}>
                                                                                                    <span style={{ fontWeight: 'bold' }}>{option.optionName}</span>
                                                                                                    <span style={{ marginLeft: 8 }}>￡{option.totalPrice}</span>
                                                                                                    {/* SubOptions */}
                                                                                                    {option?.subOptions?.length > 0 && (
                                                                                                        <div style={{ marginLeft: '1.5rem', marginTop: '0.2rem' }}>
                                                                                                            {option.subOptions.map((subOption, sIdx) => (
                                                                                                                <div key={sIdx}>
                                                                                                                    <span>{subOption.subOptionName}</span>
                                                                                                                    <span style={{ marginLeft: 8 }}>￡{subOption.totalPrice}</span>
                                                                                                                </div>
                                                                                                            ))}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            }
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <span style={{ color: 'gray' }}>No Addons</span>
                                                        )}
                                                    </TableCell>

                                                    {/* Addon Tips */}
                                                    <TableCell align="center">
                                                        <Typography>{CalculateAddonFullTipsAndServiceCharage(item, "Tips")?.toFixed(2)}</Typography>
                                                    </TableCell>

                                                    {/* Addon Service Charge */}
                                                    <TableCell align="center">
                                                        <Typography>{CalculateAddonFullTipsAndServiceCharage(item, "ServiceCharge")?.toFixed(2)}</Typography>
                                                    </TableCell>

                                                    {/* Addon Service Charge Vat */}
                                                    <TableCell align="center">
                                                        <Typography>{CalculatedServiceChargeVatForAddOn(item, selectedRowToRefund)?.toFixed(2)}</Typography>
                                                    </TableCell>

                                                    {/* Total Amount */}
                                                    <TableCell>
                                                        <Typography style={{ textWrap: "nowrap" }}>￡ {GetFoodItemTotalAmount(item).toFixed(2)}</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </React.Fragment>
                                        ))}

                                        {row?.items?.filter(item => item.qty > 0).length === 0 &&
                                            <h5 style={{ color: 'gray' }}>All items are refunded.</h5>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>

                        <Grid container className="d-flex align-items-center justify-content-center">
                            <Grid item xs={3}>
                                <Typography style={{ paddingTop: "1rem" }}>
                                    Select Tranasaction
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Autocomplete
                                    multiple
                                    id="refund-item-autocomplete"
                                    options={GetAllTransaction().filter(
                                        (item) => !selectedTransactionToRefundFrom.some(
                                            (selected) => selected.id === item.id
                                        )
                                    )}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                label={`Id: #${option?.id?.slice(-6)} - ${option?.transactionStatus} - £${option?.netAmount?.toFixed(2)}`}
                                                {...getTagProps({ index })}
                                            />
                                        ))
                                    }
                                    getOptionLabel={(item) => `Id: #${item?.id?.slice(-6)} - ${item?.transactionStatus} - ￡${item?.netAmount?.toFixed(2)}`}
                                    value={selectedTransactionToRefundFrom}
                                    onChange={(event, newValue) => {
                                        const normalized = newValue.map(x => ({
                                            ...x,
                                            netAmount: Number(x.netAmount).toFixed(2),
                                        }));
                                        withdrawRefundTransactionSelection(normalized);
                                        // withdrawRefundTransactionSelection(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            required
                                            {...params}
                                            label="Select Transactions to refund from"
                                            placeholder="Choose items"
                                            variant="outlined"
                                            sx={{ mt: 2 }}
                                        />
                                    )}
                                />
                                <span className='text-muted'>{checkForRequiredAmountToWithdraw}</span>
                            </Grid>
                        </Grid>

                        <hr />

                        {/* -- Refund Processing Type--- */}
                        <Grid container className="d-flex align-items-center justify-content-center">
                            <Grid item xs={3}>
                                <Typography style={{ paddingTop: "1rem" }}>Select Refund Processing Type</Typography>
                            </Grid>
                            <Grid item xs={9} >
                                <Autocomplete
                                    multiple={false}
                                    id="refund-item-autocomplete"
                                    options={refundProcessingType}
                                    getOptionLabel={(type) => `${type.label}`}
                                    value={selectedRefundProcessingType}
                                    onChange={(event, newValue) => {
                                        setSelectedRefundProcessingType(newValue)
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select way to refund"
                                            placeholder="Choose ways"
                                            variant="outlined"
                                            sx={{ mt: 2 }}
                                        />
                                    )}
                                />
                                {refundProcessingTypeValidationError &&
                                    <span style={{ color: 'red' }}>*Please Select a refund processing type</span>
                                }
                            </Grid>
                        </Grid>

                        {/* -- Email Address -- */}
                        {selectedRefundProcessingType?.id === 1 &&
                            <Grid container style={{ paddingTop: "0.5rem" }} className="d-flex align-items-center justify-content-center">
                                <Grid item xs={3}>
                                    <Typography style={{ paddingTop: "1rem" }}>Email Address</Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        label="Enter Your Email Address"
                                        variant="outlined"
                                        value={emailAddressToSendRefundPaymentForm}
                                        onChange={(e) => setEmailAddressToSendRefundPaymentForm(e.target.value)}
                                        required
                                        type="email"
                                    />
                                    {emailValidationError &&
                                        <span style={{ color: "red" }}>* Please enter a valid email address.</span>
                                    }
                                </Grid>
                            </Grid>
                        }

                        {hasRemainingAmount === true &&
                            <>
                                <hr />
                                <h5 className='mt-3 mb-3 text-muted'>Withdraw Remaining Amount to:</h5>

                                <Grid container className="d-flex align-items-center justify-content-center">
                                    <Grid item xs={3}>
                                        <Typography style={{ paddingTop: "1rem" }}>Restaurant</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField
                                            id="outlined-basic"
                                            label="Restaurant"
                                            variant="outlined"
                                            InputProps={{ readOnly: true }}
                                            value={selectedRestaurant?.name}
                                            style={{ width: '100%' }}
                                        />
                                    </Grid>

                                    {selectedRestaurant === null && RefundValidationError &&
                                        <span style={{ color: 'red' }}>*Please Select a restaurant</span>
                                    }
                                </Grid>

                                {/* Bank Details Selection */}
                                <Grid container className="d-flex align-items-center justify-content-center">
                                    <Grid item xs={3}>
                                        <Typography style={{ paddingTop: "1rem" }}>Bank Details</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <Autocomplete
                                            multiple={false}
                                            id="refund-item-autocomplete"
                                            options={bankDetailsList}
                                            getOptionLabel={(item) => `${item?.accountHolderName} - ${item?.accountNumber}`}
                                            value={selectedBank}
                                            onChange={(event, newValue) => {
                                                setSelectedBank(newValue)
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Bank Details"
                                                    placeholder="Choose items"
                                                    variant="outlined"
                                                    sx={{ mt: 2 }}
                                                />
                                            )}
                                        />

                                        {selectedBank === null && RefundValidationError &&
                                            <span style={{ color: 'red' }}>*Please Select a bank details</span>
                                        }
                                    </Grid>
                                </Grid>
                            </>
                        }

                        {/* -- Reason -- */}
                        <Grid container style={{ paddingTop: "0.5rem" }}>
                            <Grid item xs={3}>
                                <Typography style={{ paddingTop: "1rem" }}>Reason</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label="Refund Reason Description"
                                    variant="outlined"
                                    value={refundReason}
                                    onChange={(e) => setRefundReason(e.target.value)}
                                    required
                                />
                                {refundReason === "" && RefundValidationError &&
                                    <span style={{ color: "red" }}>* Please provide a reason to refund.</span>
                                }
                            </Grid>
                        </Grid>
                    </div>
                }

                {/* Withdraw Partial Refund Content */}
                {withdrawPartialRefundOnAction === true &&
                    <div>
                        <Box sx={{ mb: 2, p: 2, background: '#f8f9fa', borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div>
                                <Typography variant="h6" sx={{ mt: 1, mb: 0.5, color: '#2a7fd4', fontWeight: 700 }}>
                                    Refund Amount: ￡{calculatedTotalFoodItemPrice.toFixed(2)}
                                </Typography>

                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
                                    Refund Summary
                                </Typography>
                                <div style={{ borderBottom: '1px solid #e0e0e0', margin: '12px 0', width: '300px' }} />

                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                    <strong>Refund Order ID:</strong> <span style={{ color: '#2a7fd4' }}>#{selectedRowToRefund?.id?.slice(-6)}</span>
                                </Typography>

                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                    <strong>Total Order Price:</strong> ￡{selectedRowToRefund?.totalPrice?.toFixed(2) ?? '0.00'}
                                </Typography>

                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                    <strong>Total Withdrawn Amount:</strong> ￡{selectedRowToRefund?.totalWithdrawnAmount?.toFixed(2) ?? '0.00'}
                                </Typography>

                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                    <strong>Total Remaining Amount:</strong> ￡{(selectedRowToRefund?.totalPrice - selectedRowToRefund?.totalTransactionFees - selectedRowToRefund?.totalWithdrawnAmount).toFixed(2)}
                                </Typography>

                                <Typography variant="body2" sx={{ mb: 0.5 }}>
                                    <strong>Total Transaction Fees:</strong> ￡{selectedRowToRefund?.totalTransactionFees?.toFixed(2) ?? '0.00'}
                                </Typography>


                                {/* Total Refunded Amount from other orders */}
                                <Typography
                                    variant="body2"
                                    sx={{
                                        mb: 0.5,
                                        background: 'rgba(113, 120, 128, 0.2)',
                                        width: 'fit-content',
                                        color: '#020202ff',
                                        borderRadius: '4px',
                                        px: 1
                                    }}
                                >
                                    <strong>Total Amount Needed from Other Order:</strong> ￡{
                                        (
                                            (alreadyPartialRefunded
                                                ? parseFloat(totalRefundAmount)
                                                : (
                                                    selectedRowToRefund?.totalPrice
                                                )
                                            ) - (selectedRowToRefund?.totalPrice - selectedRowToRefund?.totalTransactionFees - selectedRowToRefund?.totalWithdrawnAmount || 0)
                                        ).toFixed(2)
                                    }
                                </Typography>
                            </div>
                        </Box>

                        {/* --Item Selection-- */}
                        <Grid container className="d-flex align-items-center">
                            <Grid item xs={3}>
                                <Typography style={{ paddingTop: "1rem", fontWeight: 'bolder' }}>Refund Items</Typography>
                            </Grid>
                        </Grid>

                        {/* Item Details for Partial Refunds */}
                        <div style={{ padding: '8px' }}>
                            <TableContainer component={Paper} elevation={0}>
                                <Table size="medium">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ width: '200px', textAlign: 'center' }}>Selected Items</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}><strong>Item Name</strong></TableCell>
                                            <TableCell style={{ textAlign: 'center', width: '160px' }}><strong>Item Tips</strong></TableCell>
                                            <TableCell style={{ textAlign: 'center', width: '160px' }}><strong>Item Service Ch.</strong></TableCell>
                                            <TableCell style={{ textAlign: 'center', width: '180px' }}><strong>Item Service Ch. Vat</strong></TableCell>
                                            <TableCell style={{ width: '200px', textAlign: 'center' }} align="center"><strong>FoodItem Quantity</strong></TableCell>
                                            <TableCell style={{ width: '200px', textAlign: 'center' }}><strong>Addon Details</strong></TableCell>
                                            <TableCell style={{ width: '150px', textAlign: 'center' }}><strong>AddOn Tips</strong></TableCell>
                                            <TableCell style={{ width: '150px', textAlign: 'center' }}><strong>AddOn Service Charge</strong></TableCell>
                                            <TableCell style={{ width: '200px', textAlign: 'center' }}><strong>AddOn Service Charge Vat</strong></TableCell>
                                            <TableCell style={{ width: '150px', textAlign: 'center' }}><strong>Total Amount</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedRowToRefund?.items?.filter(item => item.qty > 0)?.map((item, index) => (
                                            <TableRow key={index}>
                                                {/* FoodItem Selection Checkbox */}
                                                <TableCell>
                                                    <Checkbox onChange={() => handleCheckboxSelection(item)} />
                                                </TableCell>

                                                {/* FoodItem Name and Price */}
                                                <TableCell style={{ textWrap: 'nowrap' }}>
                                                    <Typography style={{ fontWeight: 'bold', textWrap: 'nowrap' }}>
                                                        {item.orderItemName} - ￡{GetItemPrice(item)}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell align="center">{GetItemTips(item)}</TableCell>
                                                <TableCell align="center">{GetItemServiceCharge(item)}</TableCell>
                                                <TableCell align="center">{CalculatedServiceChargeVat(item, selectedRowToRefund)?.toFixed(2)}</TableCell>

                                                {/* FoodItem Quantity */}
                                                <TableCell align="center">
                                                    {item.qty > 1 ? (
                                                        <div className='d-flex align-items-center gap-3' style={{ minWidth: '145px' }}>
                                                            <div
                                                                className='d-flex align-items-center justify-content-center OHL-plusButton'
                                                                onClick={() => handleQuantityChange('-', item)}
                                                            >
                                                                <h3 style={{ margin: '0px' }}>-</h3>
                                                            </div>
                                                            <TextField
                                                                type="number"
                                                                size="small"
                                                                value={alteredQuantity?.some(data => data.orderItemId === item.orderItemId) ? alteredQuantity?.find(data => data.orderItemId === item.orderItemId)?.quantity : item.qty}
                                                                inputProps={{
                                                                    min: 1,
                                                                    max: item.qty,
                                                                    step: 1,
                                                                }}
                                                                disabled
                                                            />
                                                            <div
                                                                className='d-flex align-items-center justify-content-center OHL-plusButton'
                                                                onClick={() => handleQuantityChange('+', item)}
                                                            >
                                                                <h3 style={{ margin: '0px' }}>+</h3>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <Typography>{item.qty}</Typography>
                                                    )}
                                                </TableCell>

                                                {/* FoodItem AddOn Details */}
                                                <TableCell style={{ textAlign: 'center' }}>
                                                    {item?.addons?.map((addon, aIdx) => (
                                                        <div key={aIdx} className="addonRow">
                                                            {item?.qty > 1 && addon.refundStatus !== "Refunded" &&
                                                                <Checkbox
                                                                    disabled={selectedPartialRefundItems.length === 0 || !selectedPartialRefundItems?.some(foodItem => foodItem.orderItemId === item.orderItemId)}
                                                                    checked={
                                                                        item.qty > 1 &&
                                                                        !alteredQuantity?.some(data => data.orderItemId === item.orderItemId) ||
                                                                        item.qty === alteredQuantity?.find(dt => dt.orderItemId === item.orderItemId)?.quantity ||
                                                                        addOnToRefund.some(item => item.id === addon.id)
                                                                    }
                                                                    onChange={(alteredQuantity?.find(items => items.orderItemId === item.orderItemId)?.quantity === item?.qty || alteredQuantity.length === 0) ? () => AddAddONPriceWithTotal(addon) : () => handleAddonCheckbox(addon)}
                                                                />
                                                            }
                                                            <div className="addonColumn">
                                                                {addon?.refundStatus === 'Refunded' ?
                                                                    <Typography className="addonRefunded">
                                                                        <span style={{ marginRight: 6 }}>{item.addons.length > 1 ? `${aIdx + 1}.` : ''}</span>
                                                                        <span className="addonBold">{addon.addOnName} is Refuned</span>
                                                                    </Typography>
                                                                    :
                                                                    <Typography>
                                                                        <span style={{ marginRight: 6 }}>{item.addons.length > 1 ? `${aIdx + 1}.` : ''}</span>
                                                                        <span className="addonBold">{addon.addOnName} - ￡{addon.totalPrice}</span>
                                                                        {addon?.options?.length > 0 && (
                                                                            <div className="optionBlock">
                                                                                {addon.options.map((option, oIdx) => (
                                                                                    <div key={oIdx} className="optionRow">
                                                                                        <span>{option.optionName} - ￡{option.totalPrice}</span>
                                                                                        {option?.subOptions?.length > 0 && (
                                                                                            <div className="subOptionBlock">
                                                                                                {option.subOptions.map((subOption, subIdx) => (
                                                                                                    <div key={subIdx}>
                                                                                                        <span>{subOption.subOptionName} - ￡{subOption.totalPrice}</span>
                                                                                                    </div>
                                                                                                ))}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </Typography>
                                                                }
                                                            </div>
                                                        </div>
                                                    ))}

                                                    {item?.addons?.length === 0 &&
                                                        <span style={{ textAlign: 'center' }}>No add-ons to refund</span>
                                                    }
                                                </TableCell>

                                                {/* AddOn Tips */}
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    <Typography>￡{CalculatePartialAddonTipsAndServiceCharage(item, selectedRowToRefund, "Tips")}</Typography>
                                                </TableCell>

                                                {/* AddOn Service Charge */}
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    <Typography>￡{CalculatePartialAddonTipsAndServiceCharage(item, selectedRowToRefund, "ServiceCharge")}</Typography>
                                                </TableCell>

                                                {/* AddOn Service Charge Vat */}
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    <Typography>￡{CalculatedServiceChargeVatForAddOn(item, selectedRowToRefund)?.toFixed(2)}</Typography>
                                                </TableCell>

                                                {/* Total Amount */}
                                                <TableCell>
                                                    <Typography>￡{GetPartialFoodItemTotalAmount(item).toFixed(2)}</Typography>
                                                </TableCell>
                                            </TableRow>
                                        ))}

                                        {row?.items?.filter(item => item.qty > 0).length === 0 &&
                                            <h5 style={{ color: 'gray' }}>All items are refunded.</h5>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>

                        {selectedPartialRefundItems.length === 0 && RefundValidationError &&
                            <span style={{ color: "red", marginLeft: '15px' }}>* Select Items to refund.</span>
                        }

                        {/* -- Refund Processing Type--- */}
                        <Grid container className="d-flex align-items-center justify-content-center">
                            <Grid item xs={3}>
                                <Typography style={{ paddingTop: "1rem" }}>Select Refund Processing Type</Typography>
                            </Grid>
                            <Grid item xs={9} >
                                <Autocomplete
                                    multiple={false}
                                    id="refund-item-autocomplete"
                                    options={refundProcessingType}
                                    getOptionLabel={(type) => `${type.label}`}
                                    value={selectedRefundProcessingType}
                                    onChange={(event, newValue) => {
                                        setSelectedRefundProcessingType(newValue)
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select way to refund"
                                            placeholder="Choose ways"
                                            variant="outlined"
                                            sx={{ mt: 2 }}
                                        />
                                    )}
                                />
                                {selectedRefundProcessingType === null && refundProcessingTypeValidationError &&
                                    <span style={{ color: "red" }}>* Please select a valid refund processing type.</span>
                                }
                            </Grid>
                        </Grid>

                        {/* -- Email Address -- */}
                        {selectedRefundProcessingType?.id === 1 &&
                            <Grid container style={{ paddingTop: "0.5rem" }} className="d-flex align-items-center justify-content-center">
                                <Grid item xs={3}>
                                    <Typography style={{ paddingTop: "1rem" }}>Email Address</Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        label="Enter your email address"
                                        variant="outlined"
                                        value={emailAddressToSendRefundPaymentForm}
                                        onChange={(e) => setEmailAddressToSendRefundPaymentForm(e.target.value)}
                                        required
                                        type="email"
                                    />

                                    {emailValidationError &&
                                        <span style={{ color: "red" }}>* Please enter a valid email address.</span>
                                    }
                                </Grid>
                            </Grid>
                        }

                        {/* Select Transactions to refund from */}
                        <Grid container className="d-flex align-items-center justify-content-center">
                            <Grid item xs={3}>
                                <Typography style={{ paddingTop: "1rem" }}>Refund From</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Autocomplete
                                    multiple
                                    id="refund-item-autocomplete"
                                    options={GetAllTransaction().filter(
                                        (item) => !selectedTransactionToRefundFrom.some(
                                            (selected) => selected.id === item.id
                                        )
                                    )}
                                    getOptionLabel={(item) => `Id: #${item?.id?.slice(-6)} - ${item?.transactionStatus} - ￡${item?.netAmount?.toFixed(2)}`}
                                    value={selectedTransactionToRefundFrom}
                                    onChange={(event, newValue) => {
                                        withdrawRefundTransactionSelection(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            required
                                            {...params}
                                            label="Select Transactions to refund from"
                                            placeholder="Choose items"
                                            variant="outlined"
                                            sx={{ mt: 2 }}
                                        />
                                    )}
                                />
                                <span style={{ color: 'gray' }}>{checkForRequiredAmountToWithdraw}</span>

                            </Grid>
                        </Grid>

                        <hr />

                        {hasRemainingAmount === true &&
                            <>
                                <hr />
                                <h5 className='mt-3 mb-3 text-muted'>Withdraw Remaining Amount to:</h5>
                                <Grid container className="d-flex align-items-center justify-content-center">
                                    <Grid item xs={3}>
                                        <Typography>Restaurant</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField
                                            id="outlined-basic"
                                            label="Restaurant"
                                            variant="outlined"
                                            InputProps={{ readOnly: true }}
                                            value={selectedRestaurant?.name}
                                            style={{ width: '100%' }}
                                        />
                                    </Grid>
                                    {selectedRestaurant === null && RefundValidationError &&
                                        <span style={{ color: 'red' }}>*Please Select a restaurant</span>
                                    }
                                </Grid>

                                {/* Bank Details */}
                                <Grid container className="d-flex align-items-center justify-content-center">
                                    <Grid item xs={3}>
                                        <Typography>Bank Details</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <Autocomplete
                                            multiple={false}
                                            id="refund-item-autocomplete"
                                            options={bankDetailsList}
                                            getOptionLabel={(item) => `${item?.accountHolderName} - ${item?.accountNumber}`}
                                            value={selectedBank}
                                            onChange={(event, newValue) => {
                                                setSelectedBank(newValue)
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Bank Details"
                                                    placeholder="Choose items"
                                                    variant="outlined"
                                                    sx={{ mt: 2 }}
                                                />
                                            )}
                                        />
                                        {selectedBank === null && RefundValidationError &&
                                            <span style={{ color: 'red' }}>*Please Select a bank details</span>
                                        }
                                    </Grid>
                                </Grid>
                            </>
                        }

                        {/* Reason Field */}
                        <Grid container className="d-flex align-items-center justify-content-center">
                            <Grid item xs={3}>
                                <Typography>Reason</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    label="Refund Reason Description"
                                    variant="outlined"
                                    value={refundReason}
                                    onChange={(e) => setRefundReason(e.target.value)}
                                    required
                                />
                                {refundReason === "" && RefundValidationError &&
                                    <span style={{ color: "red" }}>* Please provide a reason to refund.</span>
                                }
                            </Grid>
                        </Grid>
                    </div>
                }
            </DialogContent>

            {/* Footer */}
            <DialogActions>
                {withdrawPartialRefundOnAction === true ?
                    <Button
                        onClick={WithdrawPartialRefundRequest}
                        color="primary"
                        variant="contained"
                        disabled={RefundValidationError || row?.items?.filter(item => item.qty > 0).length === 0}
                    >
                        Withdraw Partial Refund
                    </Button>
                    :
                    <Button
                        onClick={WithdrawRefundRequest}
                        color="primary"
                        variant="contained"
                        disabled={RefundValidationError || row?.items?.filter(item => item.qty > 0).length === 0}
                    >
                        Withdraw Refund
                    </Button>

                }
                <Button onClick={handleCloseRefundModals} color="secondary">
                    Close
                </Button>
            </DialogActions>
        </Dialog >
    );
}

export default MatchRefundModal;